// Fix for Section Scroll

$(document).ready(function(){
    $('.shopify-section').each(function(){
        var section = $(this);
        section.find('a').each(function(){
            var link = $(this)
            var href = link.attr('href')
            if (href && href.indexOf('#') > -1) {
                link.on('click',function(){
                    var hash = href.split('#')[1]
                    var target = $('#'+hash)
                    if (target.length > 0) {
                        $('html, body').animate({
                            scrollTop: target.offset().top - 130
                        }, 500);
                    }
                })
            }
        })
    });
})